module.exports = __webpack_public_path__ + "static/media/icon_drivers_license.8f8f100c.svg";